import urls from 'constants/urls';

export const getDeliveryUrl = () => urls.bookDeliverySlot;
